/** Render a live Eastern-Time clock, driven by the server-time estimate. */
export function startClock(el: HTMLElement, nowMs: () => number): () => void {
  const fmt = new Intl.DateTimeFormat('en-US', {
    timeZone: 'America/New_York',
    hour: 'numeric',
    minute: '2-digit',
    second: '2-digit',
  });
  const update = () => {
    el.textContent = `${fmt.format(new Date(nowMs()))} ET`;
  };
  update();
  const id = setInterval(update, 1000);
  return () => clearInterval(id);
}
